import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { ServiceAppsComponent } from './service-apps.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ServiceAppsComponent, InfoBoxComponent],
})
export class ServiceAppsModule {}
